import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MatFormFieldModule, MatSelectModule, MatTableModule, MatIconModule, MatButtonModule, MatPaginatorModule, MatSortModule, MatListModule, MatDialogModule } from '@angular/material';
import { ComponentsModule } from '../../components/components.module';
import { ProgramFaxesPage } from './program-faxes';

@NgModule({
  declarations: [
    ProgramFaxesPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramFaxesPage),
    ComponentsModule,
    MatFormFieldModule, MatSelectModule, MatTableModule, MatIconModule, MatButtonModule, MatPaginatorModule, MatSortModule, MatListModule, MatDialogModule
  ],
})
export class ProgramFaxesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-faxes/program-faxes.module.ts